import React from 'react';

interface Props {
  currentPage: number;
  totalPages: number;
  onGoTo: (page: number) => void;
  testId?: string;
}

export function PaginationControls({ currentPage, totalPages, onGoTo, testId }: Props) {
  const maxSize = 10;
  // Windows page in fixed blocks so the ellipsis lands the clicked page at the
  // block edge (start for trailing, end for leading) instead of re-centering.
  const startPage = Math.floor(currentPage / maxSize) * maxSize;
  const endPage = Math.min(totalPages - 1, startPage + maxSize - 1);
  const pages = Array.from({ length: Math.max(endPage - startPage + 1, 1) }, (_, i) => startPage + i);

  return (
    <ul className="pagination pagination-sm" data-testid={testId}>
      <li className={currentPage === 0 ? 'disabled' : ''}>
        <a onClick={() => currentPage > 0 && onGoTo(0)} data-testid="pagination-first-btn">First</a>
      </li>
      <li className={currentPage === 0 ? 'disabled' : ''}>
        <a onClick={() => currentPage > 0 && onGoTo(currentPage - 1)} data-testid="pagination-prev-btn">Previous</a>
      </li>
      {startPage > 0 && (
        <li>
          <a onClick={() => onGoTo(startPage - 1)}>…</a>
        </li>
      )}
      {pages.map(p => (
        <li key={p} className={p === currentPage ? 'active' : ''}>
          <a onClick={() => onGoTo(p)} data-testid="pagination-page-btn">{p + 1}</a>
        </li>
      ))}
      {endPage < totalPages - 1 && (
        <li>
          <a onClick={() => onGoTo(endPage + 1)}>…</a>
        </li>
      )}
      <li className={currentPage === Math.max(totalPages - 1, 0) ? 'disabled' : ''}>
        <a onClick={() => currentPage < totalPages - 1 && onGoTo(currentPage + 1)} data-testid="pagination-next-btn">Next</a>
      </li>
      <li className={currentPage === Math.max(totalPages - 1, 0) ? 'disabled' : ''}>
        <a onClick={() => currentPage < totalPages - 1 && onGoTo(totalPages - 1)} data-testid="pagination-last-btn">Last</a>
      </li>
    </ul>
  );
}
